interface AddressComponents {
  street_number?: string;
  route?: string;
  locality?: string;
  administrative_area_level_1?: string;
  postal_code?: string;
}

export const formatGoogleAddress = (place: google.maps.places.PlaceResult | undefined) => {
  if (!place) return null;

  const addressComponents: AddressComponents = {};

  place.address_components?.forEach((component) => {
    const type = component.types[0];
    if (type === 'street_number') addressComponents.street_number = component.long_name;
    if (type === 'route') addressComponents.route = component.long_name;
    if (type === 'locality') addressComponents.locality = component.long_name;
    if (type === 'administrative_area_level_1') addressComponents.administrative_area_level_1 = component.short_name;
    if (type === 'postal_code') addressComponents.postal_code = component.long_name;
  });

  return {
    line1:
      addressComponents.street_number && addressComponents.route
        ? `${addressComponents.street_number} ${addressComponents.route}`
        : place.formatted_address?.split(',')[0] || '',
    city: addressComponents.locality || '',
    state: addressComponents.administrative_area_level_1 || '',
    postalCode: addressComponents.postal_code || '',
  };
};
